import type { RouteObject } from 'react-router-dom';
import Home from '@/pages/home/page';
import Story from '@/pages/story/page';
import Cast from '@/pages/cast/page';
import News from '@/pages/news/page';
import Detail from '@/pages/detail/page';
import Search from '@/pages/search/page';
import About from '@/pages/about/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/story',
    element: <Story />,
  },
  {
    path: '/cast',
    element: <Cast />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '/detail/:id',
    element: <Detail />,
  },
  {
    path: '/search',
    element: <Search />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;